export default "images/neon-log.png";